'use strict';

angular.module('ClinicApp').controller('ModalPracticeManagementSoftwareCtrl', function($scope, $modalInstance, clinic, ClinicService, PracticeManagementSoftwareConstants, GrowlService) {
  $scope.options = PracticeManagementSoftwareConstants;
  $scope.userSelected = {};
  var submitting = false;

  $scope.getVersionOptions = function() {
    if (!$scope.userSelected.software) {
      return;
    }

    var versions = $scope.userSelected.software.versions;
    if (versions) {
      return versions.concat(['Other', "I don't know"]);
    }
  };

  $scope.showVersionInput = function() {
    return $scope.userSelected.software && !$scope.userSelected.software.versions;
  };

  $scope.onSelectSoftware = function() {
    $scope.userSelected.version = '';
  };

  $scope.canSubmit = function() {
    if ($scope.userSelected.software && !submitting) {
      if ($scope.userSelected.software.isOther) {
        return $scope.userSelected.version && $scope.userSelected.softwareOther;
      }
      if ($scope.userSelected.software.noVersion) {
        return true;
      } else {
        return !!$scope.userSelected.version;
      }
    }
  };

  $scope.submit = function() {
    submitting = true;
    return ClinicService.updateClinic(clinic, {
      metadata: {
        practiceManagementSoftware: {
          name: $scope.userSelected.software.isOther
            ? $scope.userSelected.softwareOther
            : $scope.userSelected.software.name,
          version: String($scope.userSelected.version),
        },
      },
    })
      .then(() => {
        $modalInstance.dismiss('cancel');
        GrowlService.success('Thank you! Your response has been submitted.');
      })
      .catch(() => {
        $modalInstance.dismiss('cancel');
        GrowlService.error('There was an error with your submission. We will try again later.');
      });
  };
});
